export default __webpack_public_path__ + "manageApplications.html";